import { render } from "./ProgramList.vue?vue&type=template&id=5d91859d&scoped=true"
import script from "./ProgramList.vue?vue&type=script&lang=js"
export * from "./ProgramList.vue?vue&type=script&lang=js"

import "./ProgramList.vue?vue&type=style&index=0&id=5d91859d&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d91859d"]])

export default __exports__